export class Testimonial {
    name: String;
    emailId: String;
    address: String;
    uploadMediaUrl: String;
    countryCode: String;
    countryName: String;
    mediaUrl: String;
    testimonial: String;
    createdDate: Date;
    modifiedDate: Date;
    index: number;
    
}
